import React  from 'react';
import styled from 'styled-components';

const HintSpan = styled.span`
  float     : left;
  font-size : 12px;
  color     : ${({ theme: { textColor }, error }: any): string => (error ? textColor.red : textColor.gray)};
  margin    : 0 10px;
` as any;

export const InputHint = ({ text, error }: any): JSX.Element =>
  <HintSpan error={error}>{text}</HintSpan>;
